import { render } from "./branch-create.vue?vue&type=template&id=420c80dd"
import script from "./branch-create.vue?vue&type=script&lang=js"
export * from "./branch-create.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__